<script>
import request from '@/services/request'
import { mapActions, mapGetters } from 'vuex';

import ModalFormComponent from '@/components/bank_account_provider/ModalBankAccoutProviderComponent.vue';
export default {
    props: {
        organization_charts_id: {
            default: 1,
        }
    },
    components: {
        ModalFormComponent,
    },
    data() {
        return {
            id_provider: '',
            listAr: [],
            default_account:'',
			errors: {},
        }
    },
    methods: {
        newDepartment(account = {}) {
            Event.$emit('event-show-addContBanckProvider', account);
        },
        async list(page = 1) {
            let search = {};
            let _endpoint = `/${this.id_provider}/bank_account_provider`;
            try {
                let { data } = await request.list(_endpoint, page, search)
                if (data) {
                    // console.log(data);
                    this.listAr = data;
                    let vm=this;
                    this.listAr.forEach(function(value){
                        if(value.default)
                            vm.default_account=value.id;
                    });
                }
            } catch (error) {
                // console.log(error);
            }
        },
        async changeDefault(account_id){
            const data_form = new FormData();
			data_form.append('account_id', account_id);

            let _endpoint = `/${this.id_provider}/bank_account_provider/default`;

			try {
				let { data } = await request.post(_endpoint, data_form)
				if (data) {
					this.successNotification(data.message);
                    this.list();
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					let info_error = await this.errorNotification(error);
					if (info_error == 'Logout') {
						this.$nextTick(() => {
							location.reload()
						})
					} else {
						this.errors = info_error;
					}
				}
			}

        },
        deleted: function (id) {
            let tit = 'Eliminar cuenta';
            let txt = 'Seguro que quiere eliminar al cuenta';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async(result) => {
                if (result.isConfirmed) {
                    let _endpoint = `/${this.id_provider}/bank_account_provider/${id}`;
                    try {
                        let response = await request.destroy(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        })
    },
    async mounted() {
        let id = this.$route.params.id;
        if (id) {
            this.id_provider = id;
        }
        if (this.authUser.organization_charts_id == 2 || this.authUser.organization_charts_id == 5) {
            this.id_provider = this.authUser.id;
        }
        await this.list();
    },
    created() {
        Event.$on("event-load-cont-banck-provider", () => {
            this.list();
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <div class="row">
        <div class="col-12">
            <h5 v-if="this.authUser.organization_charts_id == 2">Mis cuentas bancarias</h5>
            <h5 v-else>Cuentas Bancaria</h5>
            <button @click="newDepartment()"  type="button" class="btn btn-sm btn-outline-info float-right"
                style="margin-top:-33px">
                <i class="fa fa-plus"></i> Cuenta
            </button>
        </div>
        <div class="col-12 mt-3">
            <div class="table-responsive">
                <table class="table table-bordered text-center text-sm">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Beneficiario</th>
                            <th>Banco</th>
                            <th>Cuenta</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="listAr.length > 0">
                        <tr v-for="(account, index) in listAr" :key="index">
                            <td>{{ account.id }}</td>
                            <td>{{ account.name }}</td>
                            <td>{{ account.beneficiary }}</td>
                            <td>{{ account.bank.name }}</td>
                            <td>{{ account.account_number }}</td>
                            <td>
                                <h5><span class="badge bg-success" v-if="account.default == 1">Cuenta por defecto</span></h5>
                                <input type="radio" class="btn-check" name="default_account"  autocomplete="off"
                                    :value="account.id" v-model="default_account" :id="'default-'+index"
                                     v-if="organization_charts_id==8"
                                     @change="changeDefault(account.id)">
                                <label class="btn  m-1 btn-sm form-check-label" :for="'default-'+index"  v-if="organization_charts_id==8 && account.default == 0">Default</label>
                                <a v-tooltip.bottom-start="'Tooltip on bottom'" v-if="account.file" target="_blank"
										class="btn m-1 btn-outline-secondary btn-sm"
										:href="`${globalUrlFiles}${account.file}`">
										<i class="fas fa-file "> </i> Caratula
									</a>
                                <button  type="button" @click="newDepartment(account)"
                                    class="m-1 btn btn-outline-primary btn-sm">
                                    <i class="fas fa-edit "> </i> Editar
                                </button>
                                <button type="button" @click="deleted(account.id)"
                                    class="m-1 btn-outline-danger btn btn-sm ">
                                    <i class="fa fa-trash"></i> Eliminar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td align="center" colspan="6">Sin resultados.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <ModalFormComponent />
    </div>
</template>